import { Box, Flex } from '@modusign/design-system';
import { useEffect } from 'react';

import pushDataLayer from '@app/libs/analytics/googleTagManager';

interface GuideTooltipContentProps {
  name: string;
  title: string;
  primaryBadges?: string[];
  secondaryBadges?: string[];
  video: string;
}

function GuideTooltipContent({
  name,
  title,
  primaryBadges,
  secondaryBadges,
  video,
}: GuideTooltipContentProps) {
  useEffect(() => {
    const started = Date.now();
    return () => {
      const duration = Date.now() - started;
      if (duration < 1000) {
        return;
      }
      pushDataLayer({
        event: 'guideTooltipClosed',
        guideTooltip: {
          name: name.replace(/\s/g, ''),
          duration,
        },
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Box lineHeight={1.5} pt={3} width="380px">
      <Flex px={3}>
        <Box fontWeight="bold">{name}</Box>
        <Box flex={1} ml={4}>
          <Box fontSize={1} fontWeight="normal">
            {title}
          </Box>
          {(primaryBadges || secondaryBadges) && (
            <Flex fontSize="13px" fontWeight="normal" mt={4}>
              {primaryBadges?.map((badge) => (
                <Box
                  border="1px solid"
                  borderColor="textEmphasisLightest"
                  borderRadius="40px"
                  color="textEmphasisLightest"
                  key={badge}
                  lineHeight="18px"
                  mr={1}
                  px="10px"
                  py={1}
                >
                  {badge}
                </Box>
              ))}
              {secondaryBadges?.map((badge) => (
                <Box
                  border="1px solid"
                  borderColor="textPrimaryBase"
                  borderRadius="40px"
                  color="textPrimaryBase"
                  key={badge}
                  lineHeight="18px"
                  mr={1}
                  px="10px"
                  py={1}
                >
                  {badge}
                </Box>
              ))}
            </Flex>
          )}
        </Box>
      </Flex>
      <Box mt={7}>
        <video autoPlay height="250" loop muted playsInline>
          <source src={video} type="video/mp4" />
        </video>
      </Box>
    </Box>
  );
}

export default GuideTooltipContent;
